import useAuthStore from '../../stores/authStore';
import SuperAdminDashboard from './SuperAdminDashboard';
import SalonOwnerDashboard from './SalonOwnerDashboard';

const Dashboard = () => {
	const { user } = useAuthStore();

	if (!user) return null;

	switch (user.role) {
		case 'SUPER_ADMIN':
			return <SuperAdminDashboard />;
		case 'SALON_OWNER':
		case 'MANAGER':
			return <SalonOwnerDashboard />;
		case 'STAFF':
			return <SalonOwnerDashboard />; // For now, staff see same dashboard
		default:
			return <SuperAdminDashboard />;
	}
};

export default Dashboard;
